import React from 'react'
import CashZoneButton from '../CashZoneButton'

const CashButton = ({label, onClick}) => {
  return (
    <>
    <div className="text-center p-5">     
      <CashZoneButton label={label} onClick={onClick} link_src="#" active_color="bg-[#cc001b]" active={true} type="button" />
      </div>
    </>
  )
}

export default CashButton